import React from "react";
import { useFormContext } from "react-hook-form";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Stack from "@mui/material/Stack";

import { FormNumericInput } from "components/FormInput";

import { AmountTypeEnum } from "api";

import {
  PAYER_NAME_TOKEN,
  ORDER_NUMBER_TOKEN,
  removeTokens,
} from "shared/functions/ibanQrHelpers";

import { styles } from "./styles";

export const amountTabs = [
  {
    id: AmountTypeEnum.MerchantDefined,
    label: "Фіксована сума",
  },
  {
    id: AmountTypeEnum.PayerDefined,
    label: "Суму вводить платник",
  },
];

export const AmountTabs: React.FC = () => {
  const { watch, getValues, setValue, clearErrors, trigger } = useFormContext();

  const visibleTab = watch("amountType");

  // TODO: investigate issue with direct load
  // const ibanAccountUid = watch("ibanAccountUid");

  // const isNewAccount = !!ibanAccountUid && ibanAccountUid === "new";

  // const shouldFocusAmount = !!ibanAccountUid && !isNewAccount;

  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: AmountTypeEnum,
  ) => {
    setValue("amountType", newValue);

    if (newValue !== AmountTypeEnum.PayerDefined) {
      setValue("requestPayerFullName", false);
      setValue("requestOrderNumber", false);

      const currentPurpose = getValues("paymentPurpose") ?? "";
      const cleanedPurpose = removeTokens(currentPurpose, [PAYER_NAME_TOKEN, ORDER_NUMBER_TOKEN]);
      setValue("paymentPurpose", cleanedPurpose);
      if (cleanedPurpose !== currentPurpose) trigger("paymentPurpose");
    }
    clearErrors("amount");
  };

  return (
    <Stack sx={{ mb: 2 }} spacing={2} alignItems="flex-start">
      <Tabs
        value={visibleTab}
        onChange={handleTabChange}
        aria-label="Тип суми рахунку"
      >
        {amountTabs.map((tab) => (
          <Tab sx={styles.tab} key={tab.id} value={tab.id} label={tab.label} />
        ))}
      </Tabs>

      <FormNumericInput
        // autoFocus={shouldFocusAmount}
        title={
          visibleTab === AmountTypeEnum.MerchantDefined
            ? "Сума"
            : "Рекомендована сума"
        }
        name="amount"
        fullWidth
      />
    </Stack>
  );
};
